import useSWR from "swr";
import { fetchTactics } from "@/repositories/tactic";
import React, { useEffect, useState } from "react";
import { Tactic } from "@/types/tactic";
import { TacticSimpleCard } from "@/components/base/ui/TacticSimpleCard";

export const RelatedTactics = ({
  tactic,
  relatedTactics,
}: {
  tactic: Tactic;
  relatedTactics: (tactics: Tactic[]) => void;
}) => {
  const { data } = useSWR(
    `/api/v1/tactics?tactic_primary_id_eq=${tactic?.tactic_primary?.id}`,
    (url) =>
      fetchTactics(url, {
        "access-token": "",
        client: "",
        expiry: "",
        uid: "",
      })
  );

  useEffect(() => {
    if (data) {
      const sortData = data.sort((a: Tactic, b: Tactic) => {
        if (a.sort_order < b.sort_order) return -1;
        if (a.sort_order > b.sort_order) return 1;
        return 0;
      });
      relatedTactics(sortData);
    }
  }, [data, relatedTactics]);

  return (
    <div className={"grid md:grid-cols-4 grid-cols-2 md:gap-4 gap-2"}>
      {data?.map((it, index) => (
        <TacticSimpleCard tactic={it} key={index} />
      ))}
    </div>
  );
};
